import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../../../../../config/axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import moment from "moment";
import { useTranslation } from "react-i18next";

const CompleteStayInitialCheckinDialog = ({
  stay,
  handleSubmit,
  handleClose,
}) => {
  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  function submit(_, helpers) {
    helpers.setSubmitting(true);

    axios
      .put(`/api/v1/stays/${stay.id}.json`, {
        initial_checkin_at: new Date(),
      })
      .then(() => {
        handleSubmit();
      })
      .catch((e) => {
        if (e?.response?.data) {
          helpers.setErrors(e.response.data);
        }
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  }

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {t(
              "booking_details.guest_section.complete_stay_initial_checkin_dialog.title"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            innerRef={formRef}
            initialValues={{
              initital_checkin_at: moment().format(
                moment.HTML5_FMT.DATETIME_LOCAL
              ),
            }}
            onSubmit={submit}
          >
            <Form>
              <p>
                {t(
                  "booking_details.guest_section.complete_stay_initial_checkin_dialog.description"
                )}
              </p>
            </Form>
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button onClick={() => formRef?.current?.handleSubmit()}>
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CompleteStayInitialCheckinDialog;
